import { LoanType, LoanTypeOptions } from '../LoanConstants';

export const getLoanTypeShortName = (typeId: LoanType) => {
    const item = LoanTypeOptions.find((a) => {
        return a.id === typeId;
    });
    return item?.shortName ?? '';
};
